const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "agentName_contains",
      label: "Agent",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/ServiceTypeFilter"),
    props: {
      filterName: "supplierType_eq",
      label: "Service Type",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "not_in_use_eq",
      label: "Not In Use",
      filterValue: false,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/plugins/commissions/list-filters.js